import PropTypes from 'prop-types';

// Label-above-value field used across Perfect Store review sections.
const ReviewField = ({label, value, className = ''}) => (
  <div className={`min-w-[140px] flex-1 ${className}`.trim()}>
    <div className='review_subtitle'>{label}</div>
    <div className='review_title'>
      <span>{value || '-'}</span>
    </div>
  </div>
);

ReviewField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  className: PropTypes.string
};

export default ReviewField;
